// Module
var code = `<div id="contactModal" class="modal-dialog">
	<div class="modal-content">
		<div class="modal-header">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title" data-bind="text: title"></h4>
		</div>
		<div class="modal-body">
			<div class="form-search">
				<form data-bind="submit: function(){ return false; }">
					<input class="form-control" data-bind="textInput: search, hasfocus: hasSearchFocus" placeholder="John Doe">
					<div class="search-actions">
						<a class="clear-search" href="javascript:void(0)" data-bind="click: function(){ \$root.clickedClearSearchFilter(); \$root.hasSearchFocus(true); }, css:{ hidden: !search() }">&times;</a>
					</div>
				</form>

				<!-- ko if: selectedFilters.length > 0 -->
				<button class="btn btn-secondary" data-bind="click: function(){ showAdvancedFilters(!showAdvancedFilters()) }, css:{ active: showAdvancedFilters }" aria-label="Show advanced filters">
					<i class="fa fa-sliders"></i>
				</button>
				<!-- /ko -->
			</div>
			<!-- ko if: showAdvancedFilters() && selectedFilters.length > 0 -->
			<div class="advanced clearfix">
				<!-- ko foreach: selectedFilters -->
				<div class="btn-group" data-bind="compose: {
					model: \$root.customerFilterModel,
					activationData: {
						field: \$data,
						global: global,
						collection: 'customers',
						filter: \$root.customFieldFilters()[\$data.id],
						selectedFilters: \$root.selectedFilters
					}
				}"></div>
				<!-- /ko -->
			</div>
			<!-- /ko -->
			<!-- ko if: (!isBusy() && contacts() && contacts().length > 0) -->
			<div class="results-list" data-bind="foreach: contacts">
				<a href="javascript:void(0);" data-bind="
                    click: function(){ \$root.clickedContact(\$data); },
                    css: { selected: (\$index()==\$root.selected()), own: \$root.showOwnContact() && \$data._id == \$root.userContact._id, blocked: \$data.status == 'blocked'  }">
					<div class="media-left">
						<img class="img-circle" data-bind="contactImg: { contact: \$data, size:'S' }, attr: { alt: \$data.name}">
					</div>
					<div class="media-body">
						<!-- ko if: (\$index()==\$root.selected()) -->
						<span class="hint text-muted">↵&nbsp;Enter to accept</span>
						<!-- /ko -->
						<!-- ko if: \$data.blocked -->
						<span class="pull-right"><i class="fa fa-ban"></i> Blocked</span>
						<!-- /ko -->
						<h4 data-bind="text: name"></h4>
						<div class="text-muted">
							<document-values params="doc: \$data, fieldTypes: global.central.group.customerFields"></document-values>
						</div>
					</div>
				</a>
				<!-- ko if: \$root.showAdd && !\$root.loadMore() && \$root.search().length > 0 && \$index() == \$root.contacts().length -1 -->
				<a href="javascript:void(0);" class="text-center" data-bind="click: function(){ \$root.clickedCreate(\$root.search()); }" style="padding: 20px 5px">
					<h4>Not the <strong data-bind="text: \$root.search"></strong> that you are looking for?</h4>
					<h4><span class="fa fa-plus-circle"></span> Add user</h4>
				</a>
				<!-- /ko -->

				<!-- ko if: \$root.loadMore() && \$index() == \$root.contacts().length -1 -->
				<button class="btn btn-secondary btn-block" data-bind="click:function(){ \$root.clickedLoadMore() }, disabled: \$root.isLoadingMore(), text:(\$root.isLoadingMore()?'Loading...':'Load more')"></button>
				<!-- /ko -->
			</div>
			<!-- /ko -->
			<!-- ko if: isEmpty() && !isBusy() -->
			<div class="results-empty empty">
				<div>
					<i class="fa fa-user-group" data-bind="css:{ 'fa-user-group': \$root.kind == 'contact', 'fa-user': \$root.kind == 'user' }"></i>
					<p class="lead">
						Your search
						<!-- ko if: search().length > 0 -->
						<a class="filter" href="javascript:void(0)" data-bind="click: function(){ \$root.clickedClearSearchFilter(); }" aria-label="Clear search term"><span class="fa fa-search"></span> <span data-bind="text: search"></span></a>
						<!-- /ko -->
						did not match any user
					</p>
					<div class="empty-filters">
						<small class="text-muted">Try different search terms or tweak your filters</small>
						<!-- ko if: \$root.kind == "contact" -->
						<a href="javascript:void(0);" data-bind="click: function(){ \$root.clickedCreate(search()); }" class="filter filter-btn" style="margin-right: 5px">
							<span class="fa fa-plus-circle"></span> Add user
						</a>
						<!-- /ko -->

						<!-- ko foreach: selectedFilters -->
						<!-- ko if: !\$root.isEmptyObject(\$root.customFieldFilters()[\$data.id]()) -->
						<a class="filter" href="javascript:void(0)" data-bind="click: function(obj){ \$root.clickedClearCustomFilter(\$data); }" aria-label="Clear custom filter"><span class="fa fa-ellipsis-h"></span>
							<span data-bind="text: \$root.common.getCustomFilterText(\$data, \$root.customFieldFilters()[\$data.id]())"></span></a>
						<!-- /ko -->
						<!-- /ko -->
					</div>
				</div>
			</div>
			<!-- /ko -->
			<!-- ko if: isBusy() -->
			<div class="results-loading">
				<div class="aligner-item">
					<div class="loader-sm"></div>
				</div>
			</div>
			<!-- /ko -->
		</div>
	</div>
</div>
`;
// Exports
export default code;